import { render, staticRenderFns } from "./InsightsFeatures.vue?vue&type=template&id=e90b9070&"
import script from "./InsightsFeatures.vue?vue&type=script&lang=js&"
export * from "./InsightsFeatures.vue?vue&type=script&lang=js&"
import style0 from "./InsightsFeatures.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VThemeProvider } from 'vuetify/lib/components/VThemeProvider';
installComponents(component, {VThemeProvider})
